import React, { Component } from 'react';
import './App.css';
import {
  Button,
  Icon,
  TextField,
} from '@material-ui/core';

class PictureEditor extends Component {
  static convertPosition(originalAxeSize, showedAxeSize, position) {
    return Math.floor(position * (originalAxeSize / showedAxeSize));
  }

  constructor(props) {
    super(props);
    this.generateJson = this
      .generateJson
      .bind(this);
    this.state = {
      num: this.props.num,
      imgLocalUrl: '',
      zones: [],
    };
  }

  _handleImageChange(e) {
    e.preventDefault();

    const image = new Image();
    const file = e.target.files[0];

    image.onload = () => {
      this.setState({ imgLocalUrl: image.src });
      this.image = {
        width: image.width,
        height: image.height,
      };
    };

    image.src = window
      .URL
      .createObjectURL(file);
  }

  _handleNewDiv() {
    const { zones } = this.state;
    zones.push({ description: '' });
    this.setState({ zones });
  }

  _handleRemoveZone() {
    const { zones } = this.state;
    zones.pop();
    this.setState({ zones });
  }

  generateJson() {
    const { num } = this.state;
    const divs = [];
    const json = {};
    const showedImageSize = {
      width: document
        .getElementById(`image${num}`)
        .width,
      height: document
        .getElementById(`image${num}`)
        .height,
    };
    const divsElements = document.getElementsByClassName(`draggable image${num}`);
    for (let i = 0; i < divsElements.length; i += 1) {
      const element = divsElements[i];
      divs.push({
        left: PictureEditor.convertPosition(this.image.width, showedImageSize.width, element.getAttribute('data-x') | 0),
        top: PictureEditor.convertPosition(this.image.width, showedImageSize.width, element.getAttribute('data-y') | 0),
        // width: App.convertPosition(this.image.width, showedImageSize.width,
        // element.clientWidth | 0), height: App.convertPosition(this.image.width,
        // showedImageSize.width, element.clientHeight | 0),
        description: document
          .getElementById(`input-zone-${num}-${i}`)
          .value,
        title: document
          .getElementById(`input-title-zone-${num}-${i}`)
          .value,
      });
    }
    json.image = this.image;
    json.zones = divs;
    return json;
  }

  componentWillReceiveProps(newProps) {
    const { num } = this.state;
    console.log(newProps);
    if (num !== newProps.num) {
      console.log(num);
      this.setState({
        num: newProps,
      });
    }
  }

  render() {
    const {
      imgLocalUrl, zones, num,
    } = this.state;
    let $imagePreview = null;
    if (imgLocalUrl) {
      $imagePreview = (<img id={`image${num}`} src={imgLocalUrl} alt="" />);
    } else {
      $imagePreview = (
        <div className="no-image-text">
                    Veuillez sélectionner une image en cliquant sur le bouton ci-dessus.
        </div>
      );
    }

    const $draggableDiv = [];
    const $zonesInput = [];
    let hasImage = true;
    if (imgLocalUrl) {
      hasImage = false;
    }
    for (let i = 0; i < zones.length; i += 1) {
      $draggableDiv.push(
        <div key={`input-zone-${num}-${i}`} className={`draggable image${num}`}>
          <p>
            {`Zone ${i}`}
          </p>
        </div>,
      );
      $zonesInput.push(<TextField
        key={`input-title-zone-${num}-${i}`}
        id={`input-title-zone-${num}-${i}`}
        label={`Titre zone ${i}`}
        helperText={`Placer ici le titre qui apparaîtra lors du survol de la zone${i}`}
      />);
      $zonesInput.push(<TextField
        key={`input-zone-${num}-${i}`}
        id={`input-zone-${num}-${i}`}
        label={`Description zone ${i}`}
        helperText={`Placer ici le texte qui apparaîtra lors du survol de la zone${i}`}
        multiline
        rows="3"
      />);
    }
    return (
      <div className="picture-editor">
        <div className="button-container">
          <Button variant="contained" size="large">
            <Icon>
                            panorama
            </Icon>
            <input
              className="fileInput"
              type="file"
              onChange={e => this._handleImageChange(e)}
            />
          </Button>
          <Button
            variant="contained"
            size="large"
            disabled={hasImage}
            onClick={e => this._handleNewDiv(e)}
          >
            <Icon>
                            add
            </Icon>
                        Nouvelle Zone
          </Button>
          <Button
            variant="contained"
            size="large"
            disabled={hasImage}
            onClick={e => this._handleRemoveZone(e)}
          >
            <Icon>
                            remove
            </Icon>
                        Enlever Zone
          </Button>
          <Button
            variant="contained"
            size="large"
            disabled={hasImage}
            onClick={e => this.props.handleMoveUp(num)}
          >
            <Icon>
                            arrow_upward
            </Icon>
                        Monter
          </Button>
          <Button
            variant="contained"
            size="large"
            disabled={hasImage}
            onClick={e => this.props.handleMoveDown(num)}
          >
            <Icon>
                            arrow_downward
            </Icon>
                        Descendre
          </Button>
          <Button
            variant="contained"
            size="large"
            color="secondary"
            onClick={e => this.props.handleRemoveEditor(num)}
          >
            <Icon>
                            clear
            </Icon>
                        Supprimer
          </Button>
        </div>
        <div className="description-input-container">
          {$zonesInput}
        </div>
        <div className="imgPreview">
          <div className="dragzone">
            {$draggableDiv}
            {$imagePreview}
          </div>
        </div>
      </div>
    );
  }
}

export default PictureEditor;



// WEBPACK FOOTER //
// ./src/PictureEditor.jsx